<template>
    <!-- Recent announcements + latest poll, shared by every Today phase.
         Renders nothing at all (no header) when #experience is disabled or
         nothing recent exists — the block earns its top-of-page slot. -->
    <div v-if="enabled && (posts.length || latestPoll)">
        <div class="columns is-gapless is-mobile mb-3">
            <div class="column is-narrow">
                <i class="fal fa-bullhorn fa-fw is-size-4 mr-3"></i>
            </div>
            <div class="column">
                <h4>Announcements</h4>
            </div>
        </div>

        <announcements-rail
            :posts="posts"
            :reg-id="regId"
            :is-staff="isStaff"
            @changed="$emit('changed')"
        />

        <!-- The most recent poll stays answerable from Today even when it has
             scrolled out of the recent-announcements slice. -->
        <div v-if="latestPoll" class="mt-5">
            <div class="columns is-gapless is-mobile mb-3">
                <div class="column is-narrow">
                    <i class="fal fa-poll-people fa-fw is-size-4 mr-3"></i>
                </div>
                <div class="column">
                    <h4>Latest Poll</h4>
                </div>
            </div>
            <post-card
                :post="latestPoll"
                :reg-id="regId"
                :is-staff="isStaff"
                @changed="$emit('changed')"
            />
        </div>
    </div>
</template>

<script>
    import AnnouncementsRail from '../experience/AnnouncementsRail.vue';
    import PostCard from '../experience/PostCard.vue';

    export default {
        name: 'TodayAnnouncements',
        components: {AnnouncementsRail, PostCard},
        props: {
            enabled: {type: Boolean, default: false},
            posts: {type: Array, required: true},
            // Set only when the latest poll is NOT already in `posts`.
            latestPoll: {type: Object, default: null},
            regId: {type: Number, required: true},
            isStaff: {type: Boolean, default: false}
        }
    };
</script>
